/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiBudgetRecommendationsResponseV2,
  ApiCreateBudgetGroupRequest,
  BudgetGroupResponse,
  GetAllRecommendedBudgetsV2Params,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiBudgetControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-budget-controller-v-2
   * @name CreateBudget
   * @request POST:/api/v2/budgets
   */
  createBudget = (data: ApiCreateBudgetGroupRequest, params: RequestParams = {}) =>
    this.http.request<BudgetGroupResponse, any>({
      path: `/v2/budgets`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createBudgetPath = '/v2/budgets'
  static createBudgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller-v-2
   * @name GetAllRecommendedBudgetsV2
   * @request GET:/api/v2/budgets/recommended-to
   */
  getAllRecommendedBudgetsV2 = (
    query: GetAllRecommendedBudgetsV2Params,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiBudgetRecommendationsResponseV2, any>({
      path: `/v2/budgets/recommended-to`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllRecommendedBudgetsV2Path = '/v2/budgets/recommended-to'
  static getAllRecommendedBudgetsV2Method = 'GET'
}
